export default "__VITE_ASSET__35b66532__"